import * as _ from 'lodash';
import { formValueSelector } from 'redux-form';

export const FORM_NAME = 'creditCard';

// set destroyOnUnmount / forceUnregisterOnUnmount because the specialty vehicle loan form
// spans multiple pages: https://redux-form.com/6.6.3/examples/wizard/
// and set enableReinitialize so we reset initial values even when the
// user goes down a path, clicks back, and goes down a different one
export const FORM_CONFIG = {
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  form: FORM_NAME,
};

export type CreditCardFormField = 'productId';
export type CreditCardModelProperties = { [key in CreditCardFormField]?: string };

export const FIELDS: { [key in CreditCardFormField]: CreditCardFormField } = {
  productId: 'productId',
};

export const selector = formValueSelector(FORM_NAME);

export function getModelProperties(state: ReduxState) {
  if (state.form[FORM_NAME]) {
    // if we've gone credit card  onboarding, manually build an object with
    // values, albeit only truthy values because /api/borrowers complains if
    // we send a null (but do return undefined if no values are saved)
    const modelProperties = _.pickBy(_.mapValues(FIELDS, field => selector(state, field))) as CreditCardModelProperties;

    if (!_.isEmpty(modelProperties)) {
      return modelProperties;
    }
  }
}
